export const HUBSPOT_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360042255093-HubSpot-Integration'
export const DRIP_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019504674-How-to-Connect-Drift-with-Drip'
export const FULLSTORY_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019666893-How-to-Integrate-Drift-with-FullStory'
export const HELP_CENTER_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019504694-How-to-Connect-Drift-with-Your-Support-Knowledge-Base'
export const ZAPIER_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019665513-How-to-Connect-Drift-to-Your-Zapier-Account'
export const INTERCOM_HELPDOC_URL = 'http://help.drift.com/integrations/intercom-integration'
export const LINKEDIN_HELPDOC_URL = 'https://help.drift.com/article/linkedin-integration/'


// WEBPACK FOOTER //
// ./src/scripts/constants/HelpDocConstants.js